<template lang="pug">
div
  v-form(ref="form")
    v-row(no-gutters)
      v-col(:cols="blast.enabled ? 12 : 7")
        v-card.rounded-lg.content-box.pa-6(outlined)
          v-row
            v-col(:cols="blast.enabled ? 7 : 12")
              v-row(align="center")
                v-col.grow
                  div.d-flex.align-center
                    .text-md.font-semibold SMS delivery
                    y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
                v-col.shrink(v-if="blastData && blast.enabled && checkPaused(blastData)")
                  y-button(label="Resolve" outlined size="xxs" @click="showResolveDialog = true")
                v-col.shrink
                  y-switch.mb-n3(v-model="blast.enabled")

              v-row.my-4(v-if="blast.enabled")
                v-divider.neutral300

              template(v-if="blast.enabled")
                //- Sender ID
                div.text-md.font-semibold.neutral700--text Sender ID
                v-text-field.text-sm.mt-2.round-xl(v-model="senderID" placeholder="Sender ID" outlined dense disabled height="48" readonly :loading="isFetching" hide-details="auto")
                  template(v-slot:append)
                    v-btn.button-sm(outlined style="margin-top: -2px" @click.stop="handleRedirectSenderId") Edit
                //- Offer message
                div.text-md.font-semibold.neutral700--text.mt-5 Offer message
                v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" :prefix="senderIDPrefix" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
                div.text-sm.font-normal.neutral700--text.text-right.mt-1 Character Count {{contentLength.length}} | SMS Count {{contentLength.numSMS}} | Cost RM {{contentLength.cost.toFixed(2)}} per recipient
                template(v-if="offer.redeem_method != 'show_message'")
                  div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
                  v-chip.mt-1.mr-1(v-if="offer.end_after_value && offer.end_after_unit" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                    span.neutral700--text Expiry date
                  v-chip.mt-1.mr-1(link small outlined color="neutral400" @click="insertValue('offer_code')")
                    span.neutral700--text Redemption code
                  v-chip.mt-1(v-if="hasSmsHeader" link small outlined color="neutral400" @click="insertValue('brand_name')")
                    span.neutral700--text Brand name (Sender ID)

            v-divider.neutral300.my-n3(v-if="blast.enabled" vertical)
            //- SMS preview
            v-col.pt-0(v-if="blast.enabled" cols="5")
              sms-preview(title="Offer message preview" :sender="senderIDPrefix" :content="blast.content")
  .dialogs
    resolve-paused-preset-dialog(v-if="showResolveDialog" :open.sync="showResolveDialog" :preset="preset" :blast="blastData" @updated="$emit('resolved')")

</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import SmsPreview from '@/components/clinic/marketing/SmsPreview.vue'
import ResolvePausedPresetDialog from '@/components/clinic/marketing/dialogs/ResolvePausedPresetDialog.vue'

export default {
  components: { DatePickerField, SmsPreview, ResolvePausedPresetDialog},
  props: {
    blastData: {
      type: Object,
      default: null
    },
    sendDelaySelection: {
      type: Object,
      default: () => {
        return {
          timeValue: 1,
          timeUnit: 'hours'
        }
      }
    }
  },
  data() {
    return {
      isFetching: false,
      showResolveDialog: false,
      cursorPosition: 0,
      blast: {
        name: 'Offer message',
        send_cue: 'preset',
        type: 'offer',
        method: 'sms',
        enabled: true,
        content: null
      },
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer',
      setting: 'marketing/getMarketingSettings'
    }),
    hasSmsHeader() {
      return this.setting && this.setting.sms_header
    },
    senderID() {
      let text = null
      if (this.hasSmsHeader) {
        text = `RM0 ${this.setting.sms_header}`
      }
      return text
    },
    senderIDPrefix() {
      return `${this.senderID}: `
    },
    contentLength() {
      let text = this.blast?.content || ''
      text = text + this.senderIDPrefix
      text = text.replace(/{{ offer_code }}/g, this.replaceCodeValue)
      text = text.replace(/{{ expiry_date }}/g, this.replaceExpiryDataValue)
      text = text.replace(/{{ brand_name }}/g, this.replaceBrandNameValue)
      const length = text ? text.length : 0;
      const charLength = 155
      const numSMS = Math.ceil(length / charLength);
      const cost = numSMS * 0.15
      return {length, numSMS, cost};
    },
    textarea() {
      return this.$refs.textarea.$el.querySelector('textarea')
    },
    replaceCodeValue() {
      if (this.offer.redeem_method === 'unique_code') return 'CODE'
      if (this.offer.redeem_method === 'general_code') return this.offer.coupon_code ?? ''
      return ''
    },
    replaceExpiryDataValue() {
      if (this.offer.end_after_value && this.offer.end_after_unit) return 'DD/MM/YYYY'
      return ''
    },
    replaceBrandNameValue() {
      if (this.hasSmsHeader) return this.setting.sms_header
      return ''
    },
    preset () {
      return this.offer.name.toLowerCase()
    },
  },
  watch: {},
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData() {
      if (this.blastData) {
        this.blast = JSON.parse(JSON.stringify(this.blastData))
      }
    },
    updateCursor() {
      const position = this.textarea.selectionStart
      if (!position) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue(value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    validateData() {
      return this.$refs.form.validate()
    },
    saveData() {
      if (!this.validateData()) {
        return
      }
      if (!this.blastData && !this.blast.enabled) {
        return
      }
      const payload = this.getPayload()
      if (this.blast.id) {
        return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
      }
      return this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
    },
    handleRedirectSenderId() {
      this.$router.push('/admin/clinic/settings/marketing')
    },
    getAutoSendDelayPayload(payload) {
      if (this.offer.name === 'First purchase' || this.offer.name === 'Second purchase') {
        payload.send_cue = 'auto_send_delay'
        payload.auto_send_delay_time_value = this.sendDelaySelection.timeValue
        payload.auto_send_delay_time_unit = this.sendDelaySelection.timeUnit
        payload.auto_send_delay_specific_time = this.sendDelaySelection.specificTime
      }
      return payload
    },
    getPayload() {
      if (!this.blast.enabled) {
        let payloadBlastDisabled = {
          enabled: false
        }
        payloadBlastDisabled = this.getAutoSendDelayPayload(payloadBlastDisabled)
        return payloadBlastDisabled
      }
      let payloadBlastEnabled = {
        enabled: true,
        name: 'Offer message',
        method: 'sms',
        type: 'offer',
        content: this.blast.content,
        send_cue: 'preset',
      }
      payloadBlastEnabled = this.getAutoSendDelayPayload(payloadBlastEnabled)
      return payloadBlastEnabled
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>